"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var _immutable = require("immutable");

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var PropertyValueDisplay = _interopRequireWildcard(require("customer-data-property-utils/PropertyValueDisplay"));

var _UIStatusDot = _interopRequireDefault(require("UIComponents/tag/UIStatusDot"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var PRIORITY_TO_STATUS_TAG_TYPE_MAP = (0, _immutable.Map)({
  LOW: 'active',
  MEDIUM: 'warning',
  HIGH: 'danger'
});
var propTypes = {
  defaultValue: _react.PropTypes.node,
  onBlur: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  onFocus: _react.PropTypes.func,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  readOnly: _react.PropTypes.bool,
  showPlaceholder: _react.PropTypes.bool,
  value: _react.PropTypes.node
};

var PropertyInputTicketPriority =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputTicketPriority, _React$Component);

  function PropertyInputTicketPriority() {
    (0, _classCallCheck2.default)(this, PropertyInputTicketPriority);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputTicketPriority).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputTicketPriority, [{
    key: "focus",
    value: function focus() {
      return this.refs.input.focus();
    }
  }, {
    key: "getPlaceholder",
    value: function getPlaceholder(property, showPlaceholder) {
      if (!showPlaceholder) {
        return '';
      }

      return property.placeholder || _I18n.default.text('customerDataProperties.PropertyInput.selectPlaceholder');
    }
  }, {
    key: "getValue",
    value: function getValue(value, defaultValue) {
      return String(value || defaultValue || '');
    }
  }, {
    key: "renderOptionWithStatusTag",
    value: function renderOptionWithStatusTag(_ref) {
      var children = _ref.children,
          className = _ref.className,
          option = _ref.option,
          onClick = _ref.onClick,
          onMouseEnter = _ref.onMouseEnter;

      if (!option.value) {
        return _react.default.createElement("li", {
          className: className,
          "data-option-value": option.value
        }, children);
      }

      return _react.default.createElement("li", {
        style: {
          padding: '8px 20px'
        },
        className: (0, _classnames.default)(className, 'pointer'),
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        title: _I18n.default.text("customerDataProperties.PropertyOptionPresets.priority." + option.value),
        "data-option-value": option.value
      }, _react.default.createElement(_UIStatusDot.default, {
        use: "" + PRIORITY_TO_STATUS_TAG_TYPE_MAP.get(option.value)
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "customerDataProperties.PropertyOptionPresets.priority." + option.value
      }));
    }
  }, {
    key: "renderValueWithStatusTag",
    value: function renderValueWithStatusTag(_ref2) {
      var value = _ref2.value;

      if (!value) {
        return _react.default.createElement("li", {
          style: {
            listStyle: 'none'
          }
        });
      }

      return _react.default.createElement("li", {
        style: {
          padding: '0px',
          listStyle: 'none'
        },
        title: _I18n.default.text("customerDataProperties.PropertyOptionPresets.priority." + value)
      }, _react.default.createElement(_UIStatusDot.default, {
        use: "" + PRIORITY_TO_STATUS_TAG_TYPE_MAP.get(value)
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "customerDataProperties.PropertyOptionPresets.priority." + value
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var transferableProps = (0, _omit.default)(['aria-required', 'autoFocus', 'baseUrl', 'data-field', 'error', 'id', 'isInline', 'getProperty', 'objectType', 'onCancel', 'onFocus', 'onInvalidProperty', 'onKeyUp', 'onSecondaryChange', 'propertyIndex', 'readOnly', 'readOnlySourceData', 'required', 'secondaryChanges', 'showError', 'subject', 'subjectId', 'onTracking', 'isRequired'], (0, _immutable.Seq)(this.props)).toJS();
      return _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, transferableProps, {
        disabled: this.props.readOnly,
        options: PropertyValueDisplay.makeOptionsFromProperty(this.props.property),
        placeholder: this.getPlaceholder(this.props.property, this.props.showPlaceholder),
        ref: "input",
        value: this.getValue(this.props.value, this.props.defaultValue),
        itemComponent: this.renderOptionWithStatusTag,
        valueRenderer: this.renderValueWithStatusTag
      }));
    }
  }]);
  return PropertyInputTicketPriority;
}(_react.default.Component);

exports.default = PropertyInputTicketPriority;
PropertyInputTicketPriority.propTypes = propTypes;
module.exports = exports.default;